// extracted by mini-css-extract-plugin
export default {"lg":"navbar_lg__-sNw2","logo":"navbar_logo__34Xwi","kita":"navbar_kita__2KnMU","nav":"navbar_nav__+1UgF","navbtn":"navbar_navbtn__jNkjf"};